import React from 'react';
import Icon from '../Icon';

var _ref = /*#__PURE__*/React.createElement(Icon, {
  name: "drag-handle",
  size: "sm",
  color: "foregroundTertiary",
  cursor: "grab"
});

var DragHandle = function DragHandle() {
  return _ref;
};

export default DragHandle;